import { atomWithStorage } from "jotai/utils";
export const networkAtom = atomWithStorage("@arc/sdk/network", "mainnet", undefined, {
    getOnInit: true,
});
//# sourceMappingURL=network.js.map